import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasAllPlatformPermissions, requiredSupportPerms } from '../utils/platformPermissions';
import { isQueueScopingOn } from '../redux/featureSlice';

// Route guard for every page this portal opens by permission — each page
// family in App.jsx sits under one, carrying the catalogue key the API checks
// for the same calls. Super Admin always passes (hasAllPlatformPermissions
// short-circuits on the session flag); a platform staff member passes only
// when EVERY listed permission is granted by their role. Anyone else (or a
// staff member missing one) bounces to "/", which resolves to the first page
// they may open, or the no-access page when there is none.
//
// The sidebar only hides links; this closes the deep-link hole. The backend is
// still the real gate — every support event re-checks the permission live.
//
// `perms` is written for queue scoping ON (support.view + support.queue.X).
// When the Super Admin turns `support.queueScoping` off, the per-queue ids
// stop counting — support.view alone opens both queues, exactly as the
// server's canViewQueue then decides — so they are filtered out here rather
// than at every <Route> in App.jsx.
export default function PlatformPermissionRoute({ perms = [] }) {
  const queueScopingOn = useSelector(isQueueScopingOn);
  if (!hasAllPlatformPermissions(requiredSupportPerms(perms, queueScopingOn))) {
    return <Navigate to="/" replace data-testid="platform-permission-route-redirect" />;
  }
  return <Outlet />;
}
